<template>
  <div class="app-shell">
    <div class="app-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
:root {
  --primary-color: #3b82f6;
  --primary-hover: #2563eb;
  --primary-light: #dbeafe;
  --app-bg:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.18), transparent 28%),
    radial-gradient(circle at 85% 10%, rgba(16, 185, 129, 0.12), transparent 20%),
    linear-gradient(180deg, #09111d 0%, #0f1729 45%, #09111d 100%);
  --app-text: #e2e8f0;
}

html, body, #app {
  min-height: 100%;
  margin: 0;
  background: #ffffff;
}

body {
  color: #111827;
}

.app-shell {
  min-height: 100vh;
  background: #ffffff;
}

.app-content {
  min-height: 100vh;
  width: 100%;
}

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer components {
  .btn-primary {
    @apply bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200;
  }
  
  .card {
    @apply bg-white rounded-lg shadow-md p-6;
  }
  
  .input-field {
    @apply w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none;
  }
}
</style>
